import { BaseService } from '../../../../../core/services/BaseServices';

export class DriverGroupService extends BaseService {
  constructor() {
    super('driver/driverGroup');
  }
}
const driverGroupService = new DriverGroupService();

export default driverGroupService;
